<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment"><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
<p style="text-align: center;"><em>In each of us, there is another whom we do not know.</em></p><br/>
<p style="text-align: center;"><strong>C. G. Jung</strong></p><br/>
<p style="text-align: center;">***</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?189a20bf